import type { BackgroundColorToken } from '@canvas/constants/colors/tokens-types';

export const COLORS_TO_OMIT = new Set<BackgroundColorToken>([
  'color.background.accent.blue.bolder',
]);
